// extracted by mini-css-extract-plugin
export default {"container":"ShopForm_container__iIcqi","containerShopping":"ShopForm_containerShopping__K+KpJ","containerText":"ShopForm_containerText__qps-w","close":"ShopForm_close__TnDM3"};